import axiosClient from '../../../config/axios-client'

const MineralService = {
  getMinerals(queryString) {
    return axiosClient.get(`/dashboard/minerals?${queryString}`)
  },
  createMinerals(payload) {
    return axiosClient.post(`/dashboard/minerals`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  editMineral(mineralId, payload) {
    return axiosClient.post(`/dashboard/minerals/${mineralId}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  deleteMineral(mineralId) {
    return axiosClient.delete(`/dashboard/minerals/${mineralId}`)
  },
  updateMineralValueChain(mineralId, payload) {
    return axiosClient.post(
      `/dashboard/minerals/${mineralId}/value-chain/update`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },
  createMineralValueChain(mineralId, payload) {
    return axiosClient.post(
      `/dashboard/minerals/${mineralId}/value-chain/create`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },
  getMineral(mineralId) {
    return axiosClient.get(`/dashboard/minerals/${mineralId}`)
  },
  getMineralCountryDetails(mineralId, countryId) {
    return axiosClient.get(
      `/dashboard/minerals/${mineralId}/countries/${countryId}`,
    )
  },
  getCountries(mineralId) {
    return axiosClient.get(`/dashboard/minerals/${mineralId}/countries`)
  },
  createMineralDetailsForCountry(mineralId, countryId, payload) {
    return axiosClient.post(
      `/dashboard/minerals/${mineralId}/countries/${countryId}/create`,
      payload,
    )
  },
  updateMineralDetailsForCountry(mineralId, countryId, payload) {
    return axiosClient.post(
      `/dashboard/minerals/${mineralId}/countries/${countryId}/edit`,
      payload,
    )
  },
  deleteMineralDetailsForCountry(mineralId, countryId) {
    return axiosClient.delete(
      `/dashboard/minerals/${mineralId}/countries/${countryId}`,
    )
  },
  toggleMineralStatus(mineralId) {
    return axiosClient.post(`/dashboard/minerals/${mineralId}/status`)
  },
}

export default MineralService
